import { useEffect, useState } from "react";
import moment from "moment";
import {
  AreaChart,
  Area,
  ResponsiveContainer,
} from "recharts";
import { Card } from "../Card";

import "./styles.scss";

export const CustomAreaChart = ({data, step}) => {
  const [formattedData, setFormattedData] = useState([]);

  useEffect(() => {
    if(data && data.length > 0 && step) {
      const newData = data.map((item, index) => ({
        name: `${moment(item?.date).format()}-${index}`,
        value: item[step?.id],
      }))

      setFormattedData([{name: 'Initial', value: 0}, ...newData]);
    }
  }, [data]);

  return (
    <ResponsiveContainer width="100%" height="100%">
      <AreaChart
        width={500}
        height={400}
        data={formattedData}
        margin={{
          top: 25,
          right: 0,
          left: 0,
          bottom: 0,
        }}>
        <Area type="natural" dataKey="value" stroke="transparent" fill={step.goalAchieved ? "rgb(34, 127, 74, .2)" : "rgb(211, 17, 4, .2)"} />
      </AreaChart>
    </ResponsiveContainer>
  )
}


const KpiComponent = ({ title, subtitle, indicators, data }) => {
  return (
    <div className="kpi-card-container">
      <section className="kpi-header">
        <div className="kpi-title">{title}</div>
        <div className="kpi-subtitle">{subtitle}</div>
      </section>
      <div className="kpi-grid-container">
        {indicators && indicators.map((dt, i) => (
          <Card className="kpi-grid-card">
            <CustomAreaChart data={data} step={dt} />
            <div className="kpi-grid-card-content">
              <div className="kpi-grid-card__info--top">
                <div className="kpi-value--first">{dt?.value}</div>
                <div className="kpi-value--second">{dt?.percent ? `(${dt?.percent.toFixed(1)}%)` : ''}</div>
              </div>
              <div className="kpi-grid-card__info--bottom">
                <div className="kpi-description">{dt?.label}</div>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  )
}

export default KpiComponent